import { ApiError } from '../../../../../apiApp/controllers/Error';
import { MY_PAGE_TABS_MAP } from '../../constant';

export class MyPageTabsHookError extends ApiError {
  tab_key: keyof typeof MY_PAGE_TABS_MAP;

  constructor(message: string, tab_key: keyof typeof MY_PAGE_TABS_MAP) {
    super(message, 400);

    this.tab_key = tab_key;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MyPageTabsHookError);
    }
  }
}

export class PreRenderOnSelectedHookError extends MyPageTabsHookError {
  constructor(message: string, tab_key: keyof typeof MY_PAGE_TABS_MAP) {
    super(message, tab_key);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PreRenderOnSelectedHookError);
    }
  }
}

export class PostRenderOnSelectedHookError extends MyPageTabsHookError {
  constructor(message: string, tab_key: keyof typeof MY_PAGE_TABS_MAP) {
    super(message, tab_key);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PostRenderOnSelectedHookError);
    }
  }
}

export class RenderOnRefreshHookError extends MyPageTabsHookError {
  constructor(message: string, tab_key: keyof typeof MY_PAGE_TABS_MAP) {
    super(message, tab_key);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RenderOnRefreshHookError);
    }
  }
}
